import { useState, useEffect, useRef } from 'react';
import { renderToString } from 'react-dom/server';
import axios from 'axios';
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import TextLineEditor from './TextLineEditor';
import TextRoundLineEditor from './TextRoundLineEditor';
import NavBtn from './NavBtn';
import TamponOverview from './TamponOverview';
import ImageOptionsEditor from "./ImageOptionsEditor";

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let id = urlParams.get('ref');
let url_encre = urlParams.get('encre');

function App() {

    const defaultLine = {
        'text': '',
        'fontFamily': 'Arial',
        'fontSize': 12,
        'textAnchor': 'middle',
        'bold': false,
        'italic': false,
        'underline': false,
        'positions': {
            'x': null,
            'y': null,
        },
        'lineHeight': 1
    };

    const defaultRoundLine = {
        'text': '',
        'fontFamily': 'Arial',
        'fontSize': 12,
        'letterSpacing': 0,
        'bold': false,
        'italic': false,
        'underline': false,
        'startOffset': 0,
        'dy': 0,
        'lineHeight': 1,
        'rotation': 0,
    };

    const imageImporter = useRef(null);

    const [activatedTab, setActivatedTab] = useState('texte');
    const [encreCouleur, setEncreCouleur] = useState('noir');
    const [contour, setContour] = useState('sans');

    const [tampons, setTampons] = useState([]);
    const [filtredTampons, setFiltredTampons] = useState([]);
    const [selectedTampon, setSelectedTampon] = useState(null);

    const [motifs, setMotifs] = useState([]);
    const [selectedMotif, setSelectedMotif] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);

    const [linesTotal, setLinesTotal] = useState(null);
    const [lines, setLines] = useState([{...defaultLine}]);
    const [selectedLine, setSelectedLine] = useState(null);

    const [roundLines, setRoundLines] = useState([
        {...defaultRoundLine, offset: 15},
        {...defaultRoundLine, offset: 10},
    ]);
    const [selectedRoundLine, setSelectedRoundLine] = useState(null);

    const [filterBy, setFilterBy] = useState(null);

    const [shoppingCartLoading, setShoppingCartLoading] = useState(false);

    useEffect(async () => {
        const result = await axios(
            'https://tamporexlaser.com/wp-admin/admin-ajax.php?action=get_tampons_list'
        );

        setTampons([...result.data]);

        if(id) {
            let tamponById = result.data.filter((tampon) => tampon.id == id);

            if(tamponById.length) {
                initLines(tamponById[0]);
                setSelectedTampon({
                    ...tamponById[0]
                });

                let selectedFilterBy = 'tous';

                if(tamponById[0].metalique)
                    selectedFilterBy = 'metalique';

                if(tamponById[0].dateur)
                    selectedFilterBy = 'dateur';

                if(tamponById[0].bois)
                    selectedFilterBy = 'bois';

                if(tamponById[0].plastique)
                    selectedFilterBy = 'plastique';

                setFilterBy(selectedFilterBy);

                console.log(selectedFilterBy);

                setFiltredTampons([...result.data.filter((tampon) => {
                    return (selectedFilterBy === 'tous' || tampon[selectedFilterBy] === true);
                } )])
            }

            id = null;
        } else {
            setFilterBy('tous');

            setFiltredTampons([...result.data]);
        }

        if(url_encre) {
            setEncreCouleur(url_encre);
            url_encre = null;
        }

    }, []);


    useEffect(async () => {
        const result = await axios(
            'https://tamporexlaser.com/wp-admin/admin-ajax.php?action=get_motifs_list'
        );

        setMotifs([...result.data]);
    }, []);


    function filterTampons() {
        setFiltredTampons([...tampons.filter((tampon) => {
            return (!filterBy || tampon[filterBy] === true) && (!linesTotal || tampon.nombre_de_lignes >= linesTotal);
        } )]);
    }

    let linesTotalBtns = [];

    for(let i=1; i<=12; i++) {
        linesTotalBtns.push(
            <button
                className="btn-lignes"
                onClick={() => {
                    setLinesTotal(i);

                    setFiltredTampons([...tampons.filter((tampon) => {
                        return (!filterBy || filterBy === 'tous' || tampon[filterBy] === true) && tampon.nombre_de_lignes >= i;
                    } )])
                }}
                key={'btn-line-'+i}
                style={{opacity: linesTotal >= i ? 0.5 : 1}}
            >{i}</button>
        );
    }

    let lineInputs = [];

    if(selectedTampon && selectedTampon.forme === 'ronde') {
        for (let i = 0; i<2; i++) {
            lineInputs.push(
                <>
                    <div className={"ligne-container flexColumn" + (selectedRoundLine === i ? ' is-selected' : '')}
                         key={'round-line-' + i}>
                        <label>Ligne Ronde {i+1}</label>
                        <input
                            className="ligne-tampons"
                            type="text"
                            onChange={(e) => {
                                let newLines = roundLines.map((line) => {
                                    return {
                                        ...line
                                    }
                                });
                                newLines[i].text = e.target.value;
                                setRoundLines(newLines);
                            }}
                            onFocus={() => {
                                setSelectedRoundLine(i);
                                setSelectedLine(null);
                            }}
                            value={roundLines[i].text}
                        />
                        <button
                            className="suppr"
                            onClick={(e) => {
                                let newLines = [...roundLines.map((line, idx) => {
                                    if (idx === i) {
                                        let newLine = {
                                            ...defaultRoundLine,
                                            offset: line.offset,
                                            lineHeight: line.lineHeight
                                        };

                                        return newLine;
                                    } else {
                                        return {...line};
                                    }
                                })];

                                setRoundLines([...newLines]);

                                setSelectedRoundLine(null);
                                setSelectedLine(null);
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.1 32">
                                <defs>
                                    <style
                                        dangerouslySetInnerHTML={{__html: '.cls-2{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}'}}/>
                                </defs>
                                <title>bean</title>
                                <g id="Calque_2" data-name="Calque 2">
                                    <g id="Calque_1-2" data-name="Calque 1">
                                        <polyline className="cls-2" points="1.5 7.3 4.4 7.3 27.6 7.3"/>
                                        <path className="cls-2"
                                              d="M24.7,7.3V27.6a2.9,2.9,0,0,1-2.9,2.9H7.3a2.9,2.9,0,0,1-2.9-2.9V7.3m4.35,0V4.4a2.9,2.9,0,0,1,2.9-2.9h5.8a2.9,2.9,0,0,1,2.9,2.9V7.3"/>
                                        <line className="cls-1" x1="11.65" y1="14.55" x2="11.65" y2="23.25"/>
                                        <line className="cls-1" x1="17.45" y1="14.55" x2="17.45" y2="23.25"/>
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>
                    {
                        i === 1 &&
                        <hr style={{
                            "border": "0",
                            "borderBottom": "1px solid #dadada",
                            "margin": "25px 0",
                        }}/>
                    }
                </>
            );
        }
    }

    if(selectedTampon && selectedTampon.nombre_de_lignes) {
        for(let j=0; j<selectedTampon.nombre_de_lignes; j++) {
            lineInputs.push(
                <div className={"ligne-container flexColumn" + (selectedLine == j ? ' is-selected' : '')} key={'line-'+j}>
                    <label>Ligne {j+1}</label>
                    <input
                        className="ligne-tampons"
                        type="text"
                        onChange={(e) => {
                            let newLines = lines.map((line) => {
                                return {
                                    positions: {
                                        ...line.positions
                                    },
                                    ...line
                                }
                            });
                            newLines[j].text = e.target.value;
                            setLines(newLines);
                        }}
                        onFocus={() => {
                            setSelectedLine(j);
                            setSelectedRoundLine(null)
                        }}
                        value={lines[j].text}
                    />
                    <button
                        className="suppr"
                        onClick={(e) => {
                            let newLines = [...lines.map((line, idx) => {
                                if(idx === j) {
                                    let newLine = {
                                        ...defaultLine,
                                        positions: {
                                            ...line.positions
                                        },
                                        lineHeight: line.lineHeight
                                    };
                                    return newLine;
                                } else {
                                    return {...line};
                                }
                            })];

                            setLines([...newLines]);

                            setSelectedRoundLine(null);
                            setSelectedLine(null);
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.1 32">
                            <defs>
                                <style dangerouslySetInnerHTML={{ __html: '.cls-2{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}' }} />
                            </defs>
                            <title>bean</title>
                            <g id="Calque_2" data-name="Calque 2">
                                <g id="Calque_1-2" data-name="Calque 1">
                                    <polyline className="cls-2" points="1.5 7.3 4.4 7.3 27.6 7.3"/>
                                    <path className="cls-2"
                                          d="M24.7,7.3V27.6a2.9,2.9,0,0,1-2.9,2.9H7.3a2.9,2.9,0,0,1-2.9-2.9V7.3m4.35,0V4.4a2.9,2.9,0,0,1,2.9-2.9h5.8a2.9,2.9,0,0,1,2.9,2.9V7.3"/>
                                    <line className="cls-1" x1="11.65" y1="14.55" x2="11.65" y2="23.25"/>
                                    <line className="cls-1" x1="17.45" y1="14.55" x2="17.45" y2="23.25"/>
                                </g>
                            </g>
                        </svg>
                    </button>
                </div>
            );
        }
    };

    function initLines(tampon) {
        let newLines = [];

        if(tampon.nombre_de_lignes) {

            let first_y = tampon.nombre_de_lignes * 15 + 4;

            first_y = Math.abs((3.78*tampon.dimensions.height - first_y) / 2);

            for(let j=0; j<tampon.nombre_de_lignes; j++) {
                let line = {
                    ...defaultLine,
                    positions: {...defaultLine.positions}
                };

                line.positions.x = 3.78*tampon.dimensions.width / 2;
                line.positions.y = first_y + (j+1)*15;

                newLines.push({...line})
            }
        }

        setLines(newLines);
    }

    const slider_settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    function toDataUrl(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
            var reader = new FileReader();
            reader.onloadend = function() {
                callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }


    return (
        <main>
            <div className="module-container flexNoWrap flexColumn flexCenter">
                {
                    !selectedTampon &&
                    <div className="no-tampon-msg">
                        Veuillez sélectionner un tampon à personnaliser!
                    </div>
                }
                {
                    selectedTampon &&
                    <div className="haut-module flex">
                        <section className="options flex">
                            <nav className="sidebar-container flexColumn flexNoWrap">

                                <NavBtn
                                    src="images/icons/txt.svg"
                                    text="Texte"
                                    activated={activatedTab === 'texte'}
                                    activate={() => {
                                        setActivatedTab('texte');
                                    }}
                                />

                                <NavBtn
                                    src="images/icons/picture.svg"
                                    text="Image"
                                    activated={activatedTab === 'image'}
                                    activate={() => {
                                        setActivatedTab('image');
                                        setSelectedLine(null)
                                        setSelectedRoundLine(null)
                                    }}
                                />

                                <NavBtn
                                    src="images/icons/contours.svg"
                                    text="Contour"
                                    activated={activatedTab === 'contour'}
                                    activate={() => {
                                        setActivatedTab('contour');
                                        setSelectedLine(null)
                                        setSelectedRoundLine(null)
                                    }}
                                />

                                <NavBtn
                                    src="images/icons/goutte.svg"
                                    text="Encre"
                                    activated={activatedTab === 'encre'}
                                    activate={() => {
                                        setActivatedTab('encre');
                                        setSelectedLine(null)
                                        setSelectedRoundLine(null)
                                    }}
                                />

                            </nav>

                            <div className="parametres-container flexColumn">
                                {
                                    activatedTab === 'texte' &&
                                    <div id="parametres-texte" className="parametres-global flexColumn" style={{display: 'flex'}}>
                                        <h2 className="titre-options">Texte de l’empreinte</h2>
                                        <div className="lignes-container">
                                            {lineInputs}
                                        </div>
                                    </div>
                                }

                                {
                                    activatedTab === 'image' &&
                                    <div id="parametres-image" className="parametres-global flexColumn" style={{display: 'flex'}}>
                                        {
                                            (selectedImage === null || selectedImage.url === null) &&
                                            <>
                                                <h2 className="titre-options flexJustify flexMiddle">
                                                    Ajouter un motif

                                                    {
                                                        (selectedMotif !== null && selectedMotif.url !== null ) &&
                                                        <button
                                                            className="removemotif"
                                                            onClick={() => {
                                                                setSelectedMotif({
                                                                    ...selectedMotif,
                                                                    url: null
                                                                });
                                                            }}
                                                        >Retirer le motif</button>
                                                    }

                                                </h2>

                                                <div className="motif-container">
                                                    {
                                                        motifs &&
                                                        motifs.map((motif, idx) => (
                                                            <div
                                                                key={"motif-" + idx}
                                                                className={"motif-item" + ((selectedMotif !== null && selectedMotif.url !== null && selectedMotif.idx === idx) ? ' is-selected' : '')}
                                                                onClick={() => {

                                                                    console.log(motif);

                                                                    toDataUrl(motif, function(myBase64) {
                                                                        console.log(myBase64); // myBase64 is the base64 string

                                                                        setSelectedMotif({
                                                                            idx: idx,
                                                                            url: myBase64,
                                                                            width: (selectedMotif && selectedMotif.width) ? selectedMotif.width : 35,
                                                                            height: (selectedMotif && selectedMotif.height) ? selectedMotif.height : 35,
                                                                            x: (selectedMotif && selectedMotif.x) ? selectedMotif.x : ((3.78*selectedTampon.dimensions.width/2) - (35/2)),
                                                                            y: (selectedMotif && selectedMotif.y) ? selectedMotif.y : ((3.78*selectedTampon.dimensions.height/2) - (35/2)),
                                                                            position: (selectedMotif && selectedMotif.position) ? selectedMotif.position : 5
                                                                        });
                                                                    });
                                                                }}
                                                            >
                                                                <img src={motif} alt=""/>
                                                            </div>

                                                        ))
                                                    }
                                                </div>
                                            </>
                                        }

                                        {
                                            (selectedMotif === null || selectedMotif.url === null) &&
                                            <>
                                                <h2 className="titre-options">Importer une image</h2>

                                                <div className="bouton-img-container flexJustify">
                                                    <input
                                                        type="file"
                                                        ref={imageImporter}
                                                        style={{display: 'none'}}
                                                        onChange={(event) => {
                                                            event.stopPropagation();
                                                            event.preventDefault();
                                                            var file = event.target.files[0];

                                                            var reader = new FileReader();

                                                            reader.readAsDataURL(file);

                                                            reader.onload = function () {
                                                                var image = new Image();
                                                                image.src = reader.result;
                                                                image.onload = function() {

                                                                    let ratio = image.width / image.height;

                                                                    let image_h = 3.78*selectedTampon.dimensions.height > image.height ? image.height : (3.78*selectedTampon.dimensions.height - 30);

                                                                    if(selectedImage && selectedImage.height) {
                                                                        image_h = selectedImage.height;
                                                                    }

                                                                    let image_w =  image_h * ratio;

                                                                    setSelectedImage({
                                                                        url: reader.result,
                                                                        width: image_w,
                                                                        height: image_h,
                                                                        x: (selectedImage && selectedImage.x) ? selectedImage.x : ((3.78*selectedTampon.dimensions.width / 2) - (image_w / 2)),
                                                                        y: (selectedImage && selectedImage.y) ? selectedImage.y : ((3.78*selectedTampon.dimensions.height / 2) - (image_h / 2)),
                                                                        position: (selectedImage && selectedImage.position) ? selectedImage.position : 5
                                                                    });
                                                                };
                                                            };
                                                        }}
                                                    />


                                                    {
                                                        (selectedImage === null || selectedImage.url === null) &&
                                                        <button
                                                            className="addimage"
                                                            onClick={() => {
                                                                imageImporter.current.click();
                                                            }}
                                                        >Télécharger votre image</button>
                                                    }

                                                    {
                                                        (selectedImage !== null && selectedImage.url !== null) &&
                                                        <button
                                                            className="removeimage"
                                                            onClick={() => {
                                                                setSelectedImage({
                                                                    ...selectedImage,
                                                                    url: null
                                                                });
                                                            }}
                                                        >Retirer l’image</button>
                                                    }

                                                </div>
                                            </>
                                        }

                                        {
                                            (
                                                (selectedMotif !== null && selectedMotif.url !== null) ||
                                                (selectedImage !== null && selectedImage.url !== null )
                                            ) &&
                                            <ImageOptionsEditor
                                                frameWidth={3.78*selectedTampon.dimensions.width}
                                                frameHeight={3.78*selectedTampon.dimensions.height}
                                                properties={{
                                                    x: (selectedMotif && selectedMotif.url !== null) ? selectedMotif.x : selectedImage.x,
                                                    y: (selectedMotif && selectedMotif.url !== null) ? selectedMotif.y : selectedImage.y,
                                                    width: (selectedMotif && selectedMotif.url !== null) ? selectedMotif.width : selectedImage.width,
                                                    height: (selectedMotif && selectedMotif.url !== null) ? selectedMotif.height : selectedImage.height,
                                                    position: (selectedMotif && selectedMotif.url !== null) ? selectedMotif.position : selectedImage.position
                                                }}
                                                updateImage={(properties) => {

                                                    if(selectedMotif && selectedMotif.url !== null) {
                                                        setSelectedMotif({
                                                            ...selectedMotif,
                                                            ...properties
                                                        });
                                                    } else {
                                                        setSelectedImage({
                                                            ...selectedImage,
                                                            ...properties
                                                        });
                                                    }
                                                }}
                                            />
                                        }
                                    </div>
                                }

                                {
                                    activatedTab === 'contour' &&
                                    <div id="parametres-contour" className="parametres-global flexColumn" style={{display: 'flex'}}>
                                        <h2 className="titre-options">Contour de l’empreinte</h2>

                                        <div className="contour-container flexAround">
                                            <div
                                                id="contour1"
                                                className="contour flexColumn flexMiddle flexJustify"
                                                onClick={() => {
                                                    setContour('sans');
                                                }}
                                            >
                                                <img src="images/icons/sans.svg" alt="Contour personnalisé tampon" />
                                                <p>Sans</p>
                                            </div>

                                            <div
                                                id="contour2"
                                                className="contour flexColumn flexMiddle flexJustify"
                                                onClick={() => {
                                                    setContour('simple');
                                                }}
                                            >
                                                <img src="images/icons/simple.svg" alt="Contour personnalisé tampon" />
                                                <p>Simple</p>
                                            </div>

                                            <div
                                                id="contour3"
                                                className="contour flexColumn flexMiddle flexJustify"
                                                onClick={() => {
                                                    setContour('double');
                                                }}
                                            >
                                                <img src="images/icons/double.svg" alt="Contour personnalisé tampon" />
                                                <p>Gras</p>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {
                                    activatedTab === 'encre' &&
                                    <div id="parametres-encre" className="parametres-global flexColumn" style={{display: 'flex'}}>
                                        <h2 className="titre-options">Couleur de l’encre</h2>

                                        <div className="encre-container flexAround">
                                            <div
                                                id="encre1"
                                                className="encre flexColumn flexMiddle"
                                                onClick={() => {
                                                    setEncreCouleur('noire')
                                                }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.73 49.5"><title>goutte</title>
                                                    <g id="Calque_2" data-name="Calque 2">
                                                        <g id="Calque_1-2" data-name="Calque 1">
                                                            <path className="cls-78" d="M32.71,32.39h0a22.8,22.8,0,0,0-3.43-11.7L16.36,0,3.44,20.69A22.8,22.8,0,0,0,0,32.39H0c0,.25,0,.5,0,.75a16.37,16.37,0,0,0,32.73,0C32.73,32.89,32.72,32.64,32.71,32.39Z"/>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <p>Noire</p>
                                            </div>

                                            <div
                                                id="encre2"
                                                className="encre flexColumn flexMiddle"
                                                onClick={() => {
                                                    setEncreCouleur('rouge')
                                                }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.73 49.5"><title>goutte</title>
                                                    <g id="Calque_2" data-name="Calque 2">
                                                        <g id="Calque_1-2" data-name="Calque 1">
                                                            <path className="cls-78" d="M32.71,32.39h0a22.8,22.8,0,0,0-3.43-11.7L16.36,0,3.44,20.69A22.8,22.8,0,0,0,0,32.39H0c0,.25,0,.5,0,.75a16.37,16.37,0,0,0,32.73,0C32.73,32.89,32.72,32.64,32.71,32.39Z"/>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <p>Rouge</p>
                                            </div>

                                            <div
                                                id="encre3"
                                                className="encre flexColumn flexMiddle"
                                                onClick={() => {
                                                    setEncreCouleur('bleu')
                                                }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.73 49.5"><title>goutte</title>
                                                    <g id="Calque_2" data-name="Calque 2">
                                                        <g id="Calque_1-2" data-name="Calque 1">
                                                            <path className="cls-78" d="M32.71,32.39h0a22.8,22.8,0,0,0-3.43-11.7L16.36,0,3.44,20.69A22.8,22.8,0,0,0,0,32.39H0c0,.25,0,.5,0,.75a16.37,16.37,0,0,0,32.73,0C32.73,32.89,32.72,32.64,32.71,32.39Z"/>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <p>Bleue</p>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>

                        </section>

                        <section className="informations flexColumn flexMiddle flexJustify flexNoWrap">

                            {
                                (selectedTampon && selectedLine === null && selectedRoundLine === null) &&
                                <div className="info-tampon-container flexNoWrap flexColumn flexJustify">
                                    <div className="visu-tampon flexColumn flexNoWrap flexCenter flexMiddle">
                                        <img src={selectedTampon.image} className="image-tampons" alt="Tampons trodat personnalisé" />
                                        <h1 className="nom-tampon">{selectedTampon.title}</h1>
                                    </div>
                                    <div className="info-tampons flexColumn">
                                        <div className="info-monture flexJustify">
                                            <div className="line-label">Référence</div>
                                            <div className="line-result">{selectedTampon.sku}</div>
                                        </div>
                                        <div className="info-monture flexJustify">
                                            <div className="line-label">Lignes</div>
                                            <div className="line-result">{selectedTampon.nombre_de_lignes}</div>
                                        </div>
                                        <div className="info-monture flexJustify">
                                            <div className="line-label">Taille de l’empreinte (mm)</div>
                                            <div className="line-result">{selectedTampon.dimensions.width}x{selectedTampon.dimensions.height}</div>
                                        </div>
                                        <div className="info-monture flexJustify">
                                            <div className="line-label">Référence cartouche</div>
                                            <div className="line-result">{selectedTampon.cassette_encrage}</div>
                                        </div>
                                    </div>
                                </div>
                            }

                            {
                                selectedLine !== null &&
                                <TextLineEditor
                                    line={lines[selectedLine]}
                                    updateLine={(newLine, interline) => {
                                        let newLines = [...lines.map((line, idx) => {
                                            if(idx === selectedLine)
                                                return {
                                                    ...newLine,
                                                    ...line.positions
                                                };

                                            return {...line, ...line.positions};
                                        })];

                                        if(interline !== null && interline !== undefined) {
                                            newLines = [...newLines.map((line, idx) => {
                                                if(idx === selectedLine) {
                                                    return {
                                                        ...line,
                                                        positions: {
                                                            x: line.positions.x,
                                                            y: parseFloat(line.positions.y) + parseFloat(interline)
                                                        },
                                                    };
                                                } else if (idx > selectedLine) {
                                                    return {
                                                        ...line,
                                                        positions: {
                                                            x: line.positions.x,
                                                            y: parseFloat(line.positions.y) + parseFloat(interline)*2
                                                        }
                                                    };
                                                }

                                                return line;
                                            })];
                                        }

                                        setLines(newLines)
                                    }}
                                    width={selectedTampon.dimensions.width}
                                />
                            }

                            {
                                ( selectedRoundLine !== null && selectedTampon.forme === 'ronde' ) &&
                                <TextRoundLineEditor
                                    line={roundLines[selectedRoundLine]}
                                    updateLine={(newLine, interline) => {
                                        let newLines = [...roundLines.map((line, idx) => {
                                            if(idx === selectedRoundLine)
                                                return {...newLine};

                                            return {...line};
                                        })];
                                        setRoundLines(newLines)
                                    }}
                                    width={selectedTampon.dimensions.width}
                                />
                            }
                        </section>

                        <section className="empreinte flexColumn flexEnd">

                            <div className="visuel-empreinte-container flexColumn flexMiddle">
                                <p className="titre-empreinte">Aperçu de l'empreinte de votre tampon</p>
                                <div className="empreinte-container">
                                    {
                                        selectedTampon &&
                                        <div>
                                            <div className="tampon-dimensions" style={{
                                                "width": 3.78*selectedTampon.dimensions.width+'px',
                                                "height": 3.78*selectedTampon.dimensions.height+'px',
                                            }}>
                                                <div className="tampon-width"><span>{selectedTampon.dimensions.width} mm</span></div>
                                                <div  className="tampon-height"><span>{selectedTampon.dimensions.height} mm</span></div>
                                                <TamponOverview
                                                    lines={lines}
                                                    roundLines={roundLines}
                                                    selectedTampon={selectedTampon}
                                                    encreCouleur={encreCouleur}
                                                    contour={contour}
                                                    selectedImage={selectedImage}
                                                    motif={selectedMotif}
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>

                                {
                                    (selectedImage !== null && selectedImage.url !== null || (selectedMotif !== null && selectedMotif.url !== null) ) &&
                                    <div style={{
                                        "marginTop": "70px",
                                        "fontStyle": "italic"
                                    }}>
                                        l’image reprendra la couleur de la cartouche sélectionnée
                                    </div>
                                }
                            </div>

                            {
                                selectedTampon &&
                                <div className="panier-price-container flexMiddle flexCenter">
                                    <div className="price-module">
                                        {selectedTampon.price} €
                                        <span className="price-ttc">TTC</span>
                                    </div>
                                    <a
                                        href="#"
                                        className="addtocart"
                                        onClick={(e) => {
                                            e.preventDefault();

                                            setShoppingCartLoading(true);

                                            let form_data = new FormData;
                                            form_data.append('action', 'save_svg_tampon');
                                            form_data.append('svg', renderToString(<TamponOverview
                                                lines={lines}
                                                roundLines={roundLines}
                                                selectedTampon={selectedTampon}
                                                encreCouleur={encreCouleur}
                                                contour={contour}
                                                selectedImage={selectedImage}
                                                motif={selectedMotif}
                                            />));

                                            axios
                                                .post(
                                                    'https://tamporexlaser.com/wp-admin/admin-ajax.php',
                                                    form_data
                                                )
                                                .then((response) => {

                                                    let form_data = new FormData;

                                                    form_data.append('add-to-cart', selectedTampon.id);

                                                    form_data.append('tampon', response.data.tampon_file);
                                                    form_data.append('encre', encreCouleur);
                                                    form_data.append('contour', contour);
                                                    form_data.append('dimensions', selectedTampon.dimensions.width+'x'+selectedTampon.dimensions.height);
                                                    form_data.append('quantity', 1);

                                                    let query_lignes = [];
                                                    for(let i=0; i<selectedTampon.nombre_de_lignes; i++) {
                                                        query_lignes.push(lines[i].text);
                                                    }

                                                    form_data.append('lignes', query_lignes.join('--******--'));

                                                    if(selectedTampon.forme === 'ronde') {
                                                        let query_lignes_rondes = [];
                                                        for(let i=0; i<2; i++) {
                                                            query_lignes_rondes.push(roundLines[i].text);
                                                        }

                                                        form_data.append('lignes-rondes', query_lignes_rondes.join('--******--'));
                                                    }

                                                    const data = [...form_data.entries()];
                                                    const asString = data
                                                        .map(x => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
                                                        .join('&');

                                                    window.location.href = 'https://tamporexlaser.com/panier/?'+asString;

                                                });
                                        }}
                                    >
                                        <div className="bouton slide_rond_left flexMiddle">
                                            <div className="rond-bouton flexMiddle flexCenter">

                                                {
                                                    shoppingCartLoading &&
                                                    <img src="images/ajax-loader.gif"  alt=""/>
                                                }

                                                {
                                                    !shoppingCartLoading &&
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 44.99"><title>cart</title>
                                                        <g id="Calque_2" data-name="Calque 2">
                                                            <g id="Calque_1-2" data-name="Calque 1">
                                                                <path className="cls-8" d="M59.67,5.42a1.7,1.7,0,0,0-1.38-.7H11.22L9.93,1.13A1.72,1.72,0,0,0,8.32,0H1.71a1.71,1.71,0,0,0,0,3.42H7.12l10.08,28a1.71,1.71,0,0,0,1.61,1.13H51.73a1.71,1.71,0,0,0,0-3.42H20L19,26.18H52.41A1.71,1.71,0,0,0,54,25L59.92,7A1.68,1.68,0,0,0,59.67,5.42Zm-8.5,17.35H17.73L12.45,8.13H55.94Z"/>
                                                                <path className="cls-8" d="M24.89,33.64a5.68,5.68,0,1,0,5.68,5.68A5.68,5.68,0,0,0,24.89,33.64Zm0,7.94a2.26,2.26,0,1,1,2.26-2.26A2.27,2.27,0,0,1,24.89,41.58Z"/>
                                                                <path className="cls-8" d="M44.36,33.64A5.68,5.68,0,1,0,50,39.32,5.68,5.68,0,0,0,44.36,33.64Zm0,7.94a2.26,2.26,0,1,1,2.25-2.26A2.26,2.26,0,0,1,44.36,41.58Z"/>
                                                            </g>
                                                        </g>
                                                    </svg>
                                                }

                                            </div>

                                            <p className="text-bouton">AJOUTER AU PANIER</p>

                                        </div>
                                    </a>
                                </div>
                            }
                        </section>

                    </div>
                }


                <div className="bas-module">

                    <section className="cat-tampons-container">
                        <nav className="nbr-lignes flexColumn flexMiddle flexCenter">
                            <p>Combien de ligne minimum voulez vous ?</p>
                            <div className="ligne-1">
                                {linesTotalBtns}
                            </div>
                        </nav>
                    </section>

                    <div className="tampons-list-container">

                        <nav className="cat-nav-container flex">
                            <a
                                className={filterBy === 'tous' ? 'cat-active' : ''}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setFilterBy('tous');
                                    setFiltredTampons([...tampons.filter((tampon) => {
                                        return (!linesTotal || tampon.nombre_de_lignes >= linesTotal);
                                    } )]);
                                }}
                            >Tous</a>

                            <a
                                className={filterBy === 'metalique' ? 'cat-active' : ''}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setFilterBy('metalique');
                                    setFiltredTampons([...tampons.filter((tampon) => {
                                        return tampon.metalique === true && (!linesTotal || tampon.nombre_de_lignes >= linesTotal);
                                    } )]);
                                }}
                            >Professionnel</a>

                            <a
                                className={filterBy === 'plastique' ? 'cat-active' : ''}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setFilterBy('plastique');
                                    setFiltredTampons([...tampons.filter((tampon) => {
                                        return tampon.plastique === true && (!linesTotal || tampon.nombre_de_lignes >= linesTotal);
                                    } )]);
                                }}
                            >Printy</a>

                            <a
                                className={filterBy === 'bois' ? 'cat-active' : ''}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setFilterBy('bois');
                                    setFiltredTampons([...tampons.filter((tampon) => {
                                        return tampon.bois === true && (!linesTotal || tampon.nombre_de_lignes >= linesTotal);
                                    } )]);
                                }}
                            >Bois</a>

                            <a
                                className={filterBy === 'dateur' ? 'cat-active' : ''}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setFilterBy('dateur');
                                    setFiltredTampons([...tampons.filter((tampon) => {
                                        return tampon.dateur === true && (!linesTotal || tampon.nombre_de_lignes >= linesTotal);
                                    } )]);
                                }}
                            >Dateur</a>

                        </nav>

                        <div className="liste-tampons">
                            {
                                filtredTampons.length === 0 &&
                                <div style={{
                                    'textAlign': 'center',
                                    'padding': '30px 0px'
                                }}>Aucun tampons ne correspond à ce nombre de lignes dans la catégorie sélectionnée</div>
                            }
                            {
                                filtredTampons.length > 0 &&
                                <Slider {...slider_settings}>
                                    {
                                        filtredTampons.map((tampon, idx) => (
                                            <div
                                                className={ "tampon-item" + ((selectedTampon && selectedTampon.id === tampon.id) ? " is-selected" : "") }
                                                key={"tampon-"+idx}
                                                onClick={() => {
                                                    if(selectedTampon && selectedTampon.id === tampon.id)
                                                        setSelectedTampon(null);

                                                    initLines(tampon);
                                                    setSelectedTampon(tampon);

                                                    setSelectedLine(null);
                                                    setSelectedRoundLine(null);
                                                    setSelectedMotif({
                                                        ...selectedMotif,
                                                        url: null
                                                    });
                                                    setSelectedImage({
                                                        ...selectedImage,
                                                        url: null
                                                    });
                                                }}
                                            >
                                                <div className="tampon-img">
                                                    <img src={tampon.image} alt=""/>
                                                </div>
                                                <div className="tampon-title">{tampon.title}</div>
                                                <div className="tampon-nbre-lignes">{tampon.nombre_de_lignes} lignes</div>
                                                <div className="tampon-prix">{tampon.price} €</div>
                                                {
                                                    (selectedTampon && selectedTampon.id === tampon.id) &&
                                                    <div className="selected-tampon"></div>
                                                }
                                            </div>
                                        ))
                                    }
                                </Slider>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default App;
